import React from 'react';
import { Tabbed, Card } from '../ambient/kit';
import './portfolio.css';

// The 90-day pilot as four frames: weeks 1–2, 3–6, 7–10, 11–13. Thirteen
// week cells across the top, companies live below, the checklist for the
// phase on the right. Thirty companies at the default plan; three → twelve →
// the firm's go / no-go on the rest.
const COMPANIES = 30;
const PHASES = [
  { id: 'sign', label: 'Weeks 1–2', sub: 'sign and seat', weeks: [1, 2], live: 3, next: 0, title: 'Master agreement, three companies, the firm’s seats',
    note: 'One company per lever. Organizations are created, SSO connected, two operating partners get read-only seats.',
    checks: ['Master agreement signed; schedules for three companies', 'Three organizations created, one per lever (automate · replace · build)', 'SSO on each; the firm’s two read-only seats', 'Pilot invoice: $24,000 firm + $9,000 per first pipeline'] },
  { id: 'first', label: 'Weeks 3–6', sub: 'first pipelines', weeks: [3, 4, 5, 6], live: 3, next: 9, title: 'A gated pipeline committing in each company',
    note: 'On a real system of record, with receipts in the ledger. One Kit instance per company; managers trained on App Builder.',
    checks: ['First gated pipeline live in each of the three (ERP, ticketing, payroll)', 'One Kit instance per company in front of people', 'Managers trained on App Builder → Kit → Dev Console', 'The next nine companies picked and scheduled', { gate: true, text: 'Compliance lead reviews the ledger and the gate policy' }] },
  { id: 'nine', label: 'Weeks 7–10', sub: 'nine more', weeks: [7, 8, 9, 10], live: 12, next: 0, title: 'Twelve companies live',
    note: 'The first SaaS replacement is scoped; budget requests and prepaid credits are in use; the fleet view fills in.',
    checks: ['Nine more organizations live on the schedule', 'First SaaS replacement scoped in a Kit instance', 'Budget requests and credits in use per company', 'Fleet view shows twelve companies with cost per company'] },
  { id: 'review', label: 'Weeks 11–13', sub: 'review', weeks: [11, 12, 13], live: 12, next: 18, title: 'The week-thirteen review',
    note: 'Fleet view, ledger, cost per company, the deal model re-run on actuals. The firm chooses the remaining schedule.',
    checks: ['Every live company: one pipeline committing through a gate, one instance in front of people', 'Per-company cost within the model’s year-one line', 'Deal model re-run on actual usage', { gate: true, text: 'Go / no-go on the remaining eighteen' }] },
];

export default function Rollout({ frame = null }) {
  return (
    <Tabbed tabs={PHASES} interval={4200} start={1} h={430} frame={frame}>
      {(p) => {
        const last = p.weeks[p.weeks.length - 1];
        return (
          <div className="pf-roll">
            <div className="pf-roll-head"><h3>{p.title}</h3><span>{p.label} · {p.sub}</span></div>
            <div className="pf-roll-body">
              <div>
                <div className="pf-roll-weeks">
                  {Array.from({ length: 13 }, (_, k) => k + 1).map((w) => (
                    <div key={w} className={`pf-roll-week ${p.weeks.includes(w) ? 'is-on' : w < p.weeks[0] ? 'is-past' : ''}`}>
                      w{w}<i><b style={{ width: w <= last ? '100%' : 0 }} /></i>
                    </div>
                  ))}
                </div>
                <div className="pf-roll-live">
                  <div className="pf-roll-live-row"><span>Companies live</span><span className="pf-roll-bar"><b style={{ width: `${(p.live / COMPANIES) * 100}%` }} /></span><strong>{p.live}</strong></div>
                  <div className="pf-roll-live-row"><span>Scheduled next</span><span className="pf-roll-bar"><b style={{ width: `${(p.next / COMPANIES) * 100}%`, background: '#f5a623' }} /></span><strong>{p.next}</strong></div>
                  <div className="pf-roll-live-row"><span>Portfolio</span><span className="pf-roll-bar"><b style={{ width: '100%', background: '#22242c' }} /></span><strong>{COMPANIES}</strong></div>
                </div>
                <div className="pf-roll-companies">
                  {Array.from({ length: COMPANIES }, (_, k) => k).map((k) => (
                    <div key={k} className={`pf-roll-co ${k < p.live ? 'is-live' : k < p.live + p.next ? 'is-next' : ''}`}>
                      <span>co {String(k + 1).padStart(2, '0')}</span>
                      {k < p.live ? <em>live</em> : k < p.live + p.next ? <em>next</em> : null}
                    </div>
                  ))}
                </div>
              </div>
              <div className="pf-roll-list">
                <Card title="This phase">
                  {p.checks.map((c, k) => (typeof c === 'string'
                    ? <div key={k} className="pf-roll-check">{c}</div>
                    : <div key={k} className="pf-roll-check is-gate">{c.text}</div>))}
                </Card>
              </div>
            </div>
          </div>
        );
      }}
    </Tabbed>
  );
}
